<script>
import PaymentsListDesktopView from "./PaymentsListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders PaymentsListDesktopView using the parent payments-list instance as
 * context so template bindings and $refs stay on paymentsList.vue (provide/inject).
 */
export default {
  name: "PaymentsListDesktopBridge",
  inject: ["paymentsList"],
  render() {
    const paymentsList = this.paymentsList;
    const viewOptions = PaymentsListDesktopView.options || PaymentsListDesktopView;
    const render = viewOptions.render;

    if (!paymentsList || typeof render !== "function") {
      return null;
    }

    const options = paymentsList.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(paymentsList, paymentsList.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
